import VueTrumbowyg from 'vue-trumbowyg';
import datePicker from 'vue-bootstrap-datetimepicker';

Vue.component('mass-email', {
	components: {
		VueTrumbowyg,
		datePicker,
	},

	props: ['folder'],

	data () {
		return {
			tpOptions: {
				format: 'DD/MM/YYYY',
			},

			stage: 'select-leads',

			loading: false,

			leads: null,

			clients: null,

			ids: [],

			templates: {},

			messages: {},

			emails: {},

			success: false,

			type: null,

			filters: [],

			config: {

			},
		};
	},

	mounted () {
		$('#mass-email').on('shown.bs.modal', () => {
			// this.fetchLeads();

			this.type = null;
			this.stage = 'select-leads';
		});
	},

	methods: {
		addFilter () {
			this.filters.push({
				type: '',
				value: '',
			});
		},

		setType (type) {
			this.type = type;
			this.stage = 'select-leads';
		},

		fetchLeads () {
			this.loading = true;

			axios.get('/api/mass-email/leads', {
				params: {
					folder: this.folder,
					type: this.type,
					filters: JSON.stringify(this.filters),
				},
			}).then((response) => {
				this.leads = response.data;
				this.loading = false;

				this.ids = [];

				response.data.forEach((lead) => {
					this.ids.push(lead.quote_id);
				});
			});
		},

		configureSend () {
			this.stage = 'configure-send';
			this.loading = true;

			const ids = [];

			this.leads
				.filter((lead) => this.ids.indexOf(lead.quote_id) !== -1)
				.forEach((lead) => {
					if (ids.indexOf(lead.client_id) === -1) {
						ids.push(lead.client_id);
					}
				});

			axios.get('/api/mass-email/templates', {
				params: {
					client_ids: ids,
					type: this.type,
				}
			}).then((response) => {
				this.clients = response.data;

				this.loading = false;
			});
		},

		getTemplate (id) {
			if (!this.templates[id] || !this.emails[id]) {
				return;
			}

			this.loading = true;

			axios.get(`/api/mass-email/template/${this.templates[id]}`, {
				params: {
					from_id: this.emails[id]
				}
			})
				.then((response) => {
					this.loading = false;
					this.messages[id] = response.data;
				});
		},

		send () {
			this.loading = true;

			axios.post('/api/mass-email/send', {
				data: {
					leads: this.ids,
					messages: this.messages,
					emails: this.emails,
					type: this.type
				}
			})
				.then((response) => {
					this.loading = false;
					this.success = true;
				});
		},

		hasMessages () {
			return this.clients.filter((c) => this.messages[c.id] !== undefined).length > 0;
		}
	}
});